<script>
import {navigateTo} from "svelte-router-spa";
import Title from "../Components/Title.svelte";
import {userData} from "../Core/LocalStorage";

</script>

<div class="flex flex-1 flex-col h-full bg-hand-purple-500 pb-10">
    <div class="relative bg-white pb-16 z-0">
        <div class="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
            <Title textColor="text-hand-purple-500">
                <svg slot="icon" xmlns="http://www.w3.org/2000/svg" class="h-10 w-10" viewBox="0 0 20 20" fill="currentColor">
                    <path d="M10.707 2.293a1 1 0 00-1.414 0l-7 7a1 1 0 001.414 1.414L4 10.414V17a1 1 0 001 1h2a1 1 0 001-1v-2a1 1 0 011-1h2a1 1 0 011 1v2a1 1 0 001 1h2a1 1 0 001-1v-6.586l.293.293a1 1 0 001.414-1.414l-7-7z" />
                </svg>
                <span>
                    Hey {$userData.firstName}
                </span>
            </Title>
        </div>
    </div>
    <div class="relative flex flex-col gap-6 px-4 sm:px-6 lg:px-8 w-full max-w-6xl mx-auto">
        <div class="bg-gray-100 rounded-xl shadow-lg -mt-16 text-gray-800 z-10 grid grid-cols-2 divide-x divide-gray-200">
            <div on:click={() => navigateTo('/wages')} class="block px-4 text-center py-4 flex flex-col gap-2">
                <div class="text-hand-purple-500 text-3xl font-medium">
                    {$userData.payslipCount}
                </div>
                <div>
                    Payslip{$userData.payslipCount === 1 ? '' : 's'}<br />Available
                </div>
            </div>
            <div on:click={() => navigateTo('/docs')} class="block px-4 text-center py-4 flex flex-col gap-2">
                <div class="text-hand-purple-500 text-3xl font-medium">
                    {$userData.documentCount}
                </div>
                <div>
                    Document{$userData.documentCount === 1 ? '' : 's'}<br />Available
                </div>
            </div>
        </div>
        {#if $userData.latestPayAdvice !== null}
            <div class="bg-white rounded-xl shadow-lg p-4" on:click={() => navigateTo('/wages')}>
                <div class="text-hand-purple-500 text-sm font-medium">Your Latest Payslip</div>
                <div class="flex items-center justify-between">
                    <div>
                        {$userData.latestPayAdvice}
                    </div>
                    <div class="flex-shrink-0 flex gap-2 items-center text-3xl">
                        &pound;{$userData.latestNet}
                        <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5" viewBox="0 0 20 20" fill="currentColor">
                            <path fill-rule="evenodd" d="M10.293 5.293a1 1 0 011.414 0l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414-1.414L12.586 11H5a1 1 0 110-2h7.586l-2.293-2.293a1 1 0 010-1.414z" clip-rule="evenodd" />
                        </svg>
                    </div>
                </div>
            </div>
        {/if}
        <div class="text-white text-sm font-medium -mb-2">
            Quick Actions
        </div>
        <div class="grid grid-cols-1 gap-4">
            <div class="bg-white flex flex-col gap-3 items-center rounded-xl shadow-lg p-4" on:click={() => navigateTo('/availability')}>
                <div class="rounded-full bg-hand-pink-500 p-3">
                    <svg xmlns="http://www.w3.org/2000/svg" class="h-7 w-7 text-white" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z" />
                    </svg>
                </div>
                <span class="font-bold text-sm">My Availability</span>
            </div>

            <div class="bg-white flex flex-col gap-3 items-center rounded-xl shadow-lg p-4" on:click={() => navigateTo('/checkin')}>
                <div class="rounded-full bg-hand-orange-500 p-3">
                    <svg xmlns="http://www.w3.org/2000/svg" class="h-7 w-7 text-white" viewBox="0 0 20 20" fill="currentColor">
                        <path fill-rule="evenodd" d="M3 4a1 1 0 011-1h3a1 1 0 011 1v3a1 1 0 01-1 1H4a1 1 0 01-1-1V4zm2 2V5h1v1H5zM3 13a1 1 0 011-1h3a1 1 0 011 1v3a1 1 0 01-1 1H4a1 1 0 01-1-1v-3zm2 2v-1h1v1H5zM13 3a1 1 0 00-1 1v3a1 1 0 001 1h3a1 1 0 001-1V4a1 1 0 00-1-1h-3zm1 2v1h1V5h-1z" clip-rule="evenodd" />
                        <path d="M11 4a1 1 0 10-2 0v1a1 1 0 002 0V4zM10 7a1 1 0 011 1v1h2a1 1 0 110 2h-3a1 1 0 01-1-1V8a1 1 0 011-1zM16 9a1 1 0 100 2 1 1 0 000-2zM9 13a1 1 0 011-1h1a1 1 0 110 2v2a1 1 0 11-2 0v-3zM7 11a1 1 0 100-2H4a1 1 0 100 2h3zM17 13a1 1 0 01-1 1h-2a1 1 0 110-2h2a1 1 0 011 1zM16 17a1 1 0 100-2h-3a1 1 0 100 2h3z" />
                    </svg>
                </div>
                <span class="font-bold text-sm">Check In / Out</span>
            </div>
        </div>
    </div>
</div>